import { Button, Group, Modal, Text } from '@mantine/core';
import { useState } from 'react';
import TextInput from 'src/components/design-system/input/TextInput';

type Props = {
  opened: boolean;
  label: string;
  isDuplicating: boolean;
  onClose: () => void;
  onDuplicate: (label: string) => void;
};

/** Names the copy of a model. Mount it afresh each time it opens. */
export function DuplicateModelModal({ opened, label, isDuplicating, onClose, onDuplicate }: Props) {
  const [value, setValue] = useState(`${label} (copy)`);
  return (
    <Modal opened={opened} onClose={onClose} title="Duplicate model" centered>
      <Text size="sm" mb="md">
        The copy starts from {label} as it is today: the same people, figures and life events. It
        keeps its own history of changes from now on; the original&apos;s history stays with the
        original.
      </Text>
      <TextInput
        label="Name of the copy"
        value={value}
        onChange={event => setValue(event.currentTarget.value)}
        data-autofocus
      />
      <Group justify="flex-end" gap="sm" mt="md">
        <Button variant="subtle" size="xs" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="xs"
          disabled={!value.trim()}
          loading={isDuplicating}
          onClick={() => onDuplicate(value.trim())}
        >
          Duplicate
        </Button>
      </Group>
    </Modal>
  );
}
